import React from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import {loadAssignees} from '../../model/action-creators/assignee-actions';
import {loadWorkSessions} from '../../model/action-creators/work-session-actions';
import {loadWorkSessionTemplates} from '../../model/action-creators/work-session-template-actions';
import {doLogin, doLoginAbort, doPostLogin} from '../../model/action-creators/login-actions';
import {connect} from 'react-redux';
import {withRouter} from "react-router";

class LoginPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: props.username || "",
            password: "",
            message:""
        }
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }
    componentWillMount() {
        console.log("Mounting ", this)
    }
    componentWillUnmount() {
        console.log("Un-mounting ", this)
    }

    handleChange(event) {
        if (event.target.id === 'username-textfield') {
            this.setState({
                username: event.target.value.trim(),
            });

        } else {
            this.setState({
                password: event.target.value.trim(),
            });
        }
    }

    handleKeyUp(event) {

        if (event.keyCode === 27) {
            this.props.doLoginAbort();
        } else if (event.keyCode === 13) {
            if (this.state.password.length > 0 && this.state.username.length > 0) {
                this.handleLogin();
            }
        }
    }

    handleLogin() {
        const dispatch = this.props.dispatch;
        const router = this.props.router;
        const self = this;
        this.props.doLogin(this.state.username, this.state.password).then(
            () => {
                return dispatch(doPostLogin(true, router, "/overview"));
            }).catch(error => {
            // show message
            console.error(error);
            self.setState({
                message: error.message.trim(),
            });
        });
    }

    render() {
        return (
            <div onKeyUp={this.handleKeyUp} style={{
                display: 'flex',
                flexFlow: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100%'
            }}>
                <Paper zDepth={3} style={{padding: '1rem'}}>
                    <TextField
                        id='username-textfield'
                        hintText="Email"
                        floatingLabelText="Email"
                        onChange={this.handleChange}
                        value={this.state.username}
                        tabIndex={1}
                    /><br />
                    <TextField
                        id='password-textfield'
                        hintText="Password"
                        floatingLabelText="Password"
                        type="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        tabIndex={2}
                    /><br />
                    <div style={{
                        height: '1em',
                        color: '#f00',
                        padding: '1rem',
                        margin: 'auto',
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        {this.state.message }
                    </div>
                    <div style={{padding: '1rem', margin: 'auto', display: 'flex', justifyContent: 'center'}}>

                        <RaisedButton style={{margin: '.5rem'}} label="Login" onClick={this.handleLogin}
                                      disabled={this.state.password.length === 0 || this.state.username.length === 0}
                                      tabIndex={3}
                        />
                        <RaisedButton style={{margin: '.5rem'}} label="Cancel" onClick={this.props.doLoginAbort}
                                      tabIndex={4}
                        />

                    </div>
                </Paper>

            </div>
        )

    }
}

LoginPage.propTypes = {
    doLogin: React.PropTypes.func.isRequired,
    doLoginAbort: React.PropTypes.func.isRequired,
    username: React.PropTypes.string,
    dispatch: React.PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch:dispatch,
        doLogin: (username, password) => dispatch(doLogin(username, password)),
        doLoginAbort: () => dispatch(doLoginAbort()),
    }
};

export default connect(() => {
    return {}
}, mapDispatchToProps)(withRouter(LoginPage));



// WEBPACK FOOTER //
// ./src/ui/pages/LoginPage.js